var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolStarBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Racing/Icon/20x20px/Star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star-filled-svgrepo-com"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9785523,8.76760068 C14.922252,8.58948184 14.7650804,8.463461 14.5800938,8.463461 L11.3847185,8.463461 L10.3974531,5.27175444 C10.327748,5.11018023 10.1756032,5 9.99932976,5 C9.8230563,5 9.67057641,5.11018023 9.6022118,5.26893833 L9.60120643,5.27175444 L8.61394102,8.463461 L5.4189008,8.463461 C5.18766756,8.463461 5,8.66058857 5,8.90347789 C5,9.04921149 5.06769437,9.17875246 5.17158177,9.25865953 L5.17292225,9.25936356 L7.75770777,11.2316953 L6.77044236,14.4237539 C6.75737265,14.4645874 6.75,14.5114052 6.75,14.5599831 C6.75,14.8028724 6.93766756,15 7.1689008,15 C7.2613941,15 7.34684987,14.9686708 7.41621984,14.9151647 L7.41487936,14.9158688 L10,12.942833 L12.5847855,14.9158688 C12.652815,14.9683188 12.7382708,14.999648 12.8307641,14.999648 C13.0623324,14.999648 13.25,14.8025204 13.25,14.5592791 C13.25,14.5107012 13.2426273,14.4638834 13.2285523,14.4202337 L13.2295576,14.4234019 L12.2419571,11.2320473 L14.8274129,9.25936356 C14.9326408,9.17804844 15,9.04885948 15,8.90277387 C15,8.85454801 14.9926273,8.80773022 14.9788874,8.76443255 L14.9798928,8.76760068 L14.9785523,8.76760068 Z",
    id: "Path",
    fill: "#6176A0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-216.000000, -60.000000)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolStarBlue);
export default __webpack_public_path__ + "static/media/symbol_star_blue.637d800f8693dc569763a20ea968ba83.svg";
export { ForwardRef as ReactComponent };